import useMerchandiseSeller from './useMerchandiseSeller'

interface UseVariantSellerResult {
  seller: App.MerchandiseOfferSeller
  fetching: boolean
}

function useVariantSeller(
  offer: App.MerchandiseOffer,
  variant: App.MerchandiseOfferVariant,
): UseVariantSellerResult {
  const variantSellerId = variant.sellerId
  const needsFetch = variantSellerId && variantSellerId !== offer.seller.id

  const [fetchedSeller, fetching] = useMerchandiseSeller(needsFetch ? variantSellerId : undefined)

  return {
    seller: fetchedSeller ?? offer.seller,
    fetching,
  }
}

export default useVariantSeller
